import { TComment } from "./comment.types";

export const isThirdLevelOrBelow = (comment: TComment) => {
    return comment.rootCommentId !== null && comment.rootCommentId !== comment.parentCommentId;
};
